import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { getStatDna } from '../../../http/manager';
import ReactECharts from 'echarts-for-react';

const DnaSerial: React.FC = () => { 
    const [source, setSource] = useState()
    useEffect(()=> {
        getData();
        return;
    }, [])
    const getData = ()=> {
        getStatDna({}).then((res:any)=> {
            res.data.forEach((element:any)=> {
                element.label = {
                    formatter: [
                        '{title|{c}}',
                    ].join('\n'),
                    rich: {
                        title: {
                            color: '#000'
                        }
                    }
                }
            })
            setSource(res.data)
        })
    }
    const options = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            orient: 'vertical',
            left: '65%'
        },
        series: [
            {
                name: 'Access From',
                type: 'pie',
                radius: ['42%', '70%'],
                center: ['36%', '50%'],
                itemStyle: {
                    normal: {
                        borderColor: '#fff',
                        borderWidth: 1,
                        color: function (colors:any) {
                            var colorList = [
                            '#5B8FF9',
                            '#73DEB3'
                            ];
                            return colorList[colors.dataIndex];
                        }
                    }
                },
                data: source,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };
    return (
        <DnaContainer>
            <ReactECharts className="rechart" style={{ width: '100%', height: '100%' }} option={options} lazyUpdate={true} />
        </DnaContainer>
    )
}

export default observer(DnaSerial);

const DnaContainer = styled.div`
    & {
        width: 100%;
        height: 100%;
    }
`